var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-related"},[_c('div',{staticClass:"product-related__heading"},[_vm._v("More In")]),_vm._v(" "),_c('ProductCards',{staticClass:"product-related__cards",attrs:{"mode":"related","products":_vm.products}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }